import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchProduct, fetchItems, fetchCatalogsByProductId } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewProduct from '../components/products/ViewProduct';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import _ from 'lodash';
import Checkbox from 'material-ui/Checkbox';
import Pagination from '../components/home/Pagination';
import { cyan900 } from 'material-ui/styles/colors';
import TextField from 'material-ui/TextField';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  product: PropTypes.object,
  productId: PropTypes.string.isRequired,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
  items: PropTypes.array,
  itemsMeta: PropTypes.object,
  router: PropTypes.object,
};

class ProductViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      edited: false,
      newOptionGroup: { name: '', description: '' },
      openDeleteConfirmation: false,
      optionGroupToDelete: false,
      productOptionItems: [],
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
    const query = this.props.query;
    const router = this.props.router;
    if (!query.page) {
      query.page = 1;
      query.productId = this.props.productId;
      router.push({ pathname: location.pathname, query });
    }
    this.props.dispatch(fetchItems(query));
    this.props.dispatch(fetchProduct(this.props.productId));
    this.props.dispatch(fetchCatalogsByProductId(this.props.productId));
  }
  componentWillReceiveProps(nextProps) {
    const product = nextProps.product;
    const nullOption = { name: '', groupName: '' };
    const productOptionItems = [];
    const addItem = (item) => {
      const option = _.find(product.optionItems, { itemId: item.id }) || nullOption;
      const optionItem = {
        name: option.name,
        groupName: option.groupName,
        itemId: item.id,
        itemName: item.name,
        itemSku: item.sku,
        isDefault: option.isDefault || false,
      };
      productOptionItems.push(optionItem);
    };

    if (product && nextProps.items) {
      _.each(nextProps.items, addItem);
    }
    this.setState({ productOptionItems });
  }
  navigation(route) {
    this.props.dispatch(fetchItems(route));
  }
  renderProductImages() {
    const productImages = _.orderBy(_.get(this, 'props.product.altImages'), 'displayOrder', 'asc');
    if (!productImages) { return ''; }
    return productImages.map((image, i) =>
      <TableRow key={i}>
        <TableRowColumn style={{width: '100px'}} key={`${i}`}>{image.displayOrder}</TableRowColumn>
        <TableRowColumn key={`${i}`}>{image.url}</TableRowColumn>
      </TableRow>
    );
  }
  renderProductOptionsItemsTableRows() {
    const productOptionItems = this.state.productOptionItems;

    if (!productOptionItems) { return ''; }

    return productOptionItems.map(optionItem =>
      <TableRow key={optionItem.itemId}>
        <TableRowColumn key={`${optionItem.itemId}_itemName`}>{optionItem.itemName}</TableRowColumn>
        <TableRowColumn key={`${optionItem.itemId}_sku`}>{optionItem.itemSku}</TableRowColumn>
        <TableRowColumn key={`${optionItem.itemId}_groupName`}>{optionItem.groupName}</TableRowColumn>
        <TableRowColumn key={`${optionItem.itemId}_name`}>{optionItem.name}</TableRowColumn>
        <TableRowColumn key={`${optionItem.itemId}_name`}>
          <ul>
            <li>
              <Checkbox
                checked={optionItem.isDefault}
              />
            </li>
          </ul>
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
      inputStyleURL: {
        marginRight: '1%',
        width: '100%'
      },
    };
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="products component" style={authPage}>
        <h2>View Product</h2>
        <div className="content">
          <ViewProduct
            product={this.props.product}
          />
        </div>
        <h2>Preview Data</h2>
        <div className="content">
          <br />
          <h3 style={{ fontSize: '18px' }}>Vertical Settings</h3>
          <TextField
            floatingLabelText="Vertical Background Image Url"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.portrait.img}
            name="preview.portrait.img"
            style={styles.inputStyleURL}
          />
          <br />
          <TextField
            floatingLabelText="Vertical Preview Img X Position"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.portrait.x}
            name="preview.portrait.x"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Vertical Preview Img Y Position"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.portrait.y}
            name="preview.portrait.y"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Vertical Preview Img Width"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.portrait.width}
            name="preview.portrait.width"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Vertical Preview Img Height"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.portrait.height}
            name="preview.portrait.height"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Vertical Preview Img Angle"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.portrait.angle || 0}
            name="preview.portrait.angle"
            style={styles.inputStyle}
          />
          <br />
          <br />
          <br />
          <h3 style={{ fontSize: '18px' }}>Horizontal Settings</h3>
          <TextField
            floatingLabelText="Horizontal Background Image Url"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.landscape.img}
            name="preview.landscape.img"
            style={styles.inputStyleURL}
          />
          <br />
          <TextField
            floatingLabelText="Horizontal Preview Img X Position"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.landscape.x}
            name="preview.landscape.x"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Horizontal Preview Img Y Position"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.landscape.y}
            name="preview.landscape.y"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Horizontal Preview Img Width"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.landscape.width}
            name="preview.landscape.width"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Horizontal Preview Img Height"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.landscape.height}
            name="preview.landscape.height"
            style={styles.inputStyle}
          />
          <TextField
            floatingLabelText="Horizontal Preview Img Angle"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.product.preview.landscape.angle || 0}
            name="preview.landscape.angle"
            style={styles.inputStyle}
          />
          <br />
          <br />
        </div>
        <h2>More Product Images</h2>
        <div className="content">
          <Table selectable={false}>
            <TableHeader
              displaySelectAll={tableStyles.displaySelectAll}
              adjustForCheckbox={tableStyles.adjustForCheckbox}
            >
              <TableRow
                selectable={tableStyles.selectable}
              >
                <TableHeaderColumn style={{width:''}}>Display Order</TableHeaderColumn>
                <TableHeaderColumn>Image Url</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              stripedRows={tableStyles.stripedRows}
              displayRowCheckbox={tableStyles.displayRowCheckbox}
            >
              {this.renderProductImages()}
            </TableBody>
          </Table>
        </div>
        <h2>Product Options (Items)</h2>
        <div className="content">
          <p style={{ display: 'inline-block', float: 'left', width: '50%' }}>
          Map a product item to the corresponding option and option group
          </p>
          <div className="action-buttons top">
            <Pagination
              paginationInfo={this.props.itemsMeta}
              pageCall={route => this.navigation(route)}
              pageName={`/products/view/${_.get(this, 'props.product.id')}`}
            />
          </div>
          <br></br>
          <br></br>
          <div></div>
          <Table selectable={false} wrapperStyle={{ overflow: 'inherit' }}>
            <TableHeader
              displaySelectAll={tableStyles.displaySelectAll}
              adjustForCheckbox={tableStyles.adjustForCheckbox}
            >
              <TableRow
                selectable={tableStyles.selectable}
              >
                <TableHeaderColumn>Name</TableHeaderColumn>
                <TableHeaderColumn>SKU</TableHeaderColumn>
                <TableHeaderColumn>Option Group</TableHeaderColumn>
                <TableHeaderColumn>Option Name</TableHeaderColumn>
                <TableHeaderColumn>Default</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              stripedRows={tableStyles.stripedRows}
              displayRowCheckbox={tableStyles.displayRowCheckbox}
            >
              {this.renderProductOptionsItemsTableRows()}
            </TableBody>
          </Table>
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.itemsMeta}
            pageCall={route => this.navigation(route)}
            pageName={`/products/view/${_.get(this, 'props.product.id')}`}
          />
        </div>
      </div>
    );
  }
}

ProductViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ProductViewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  const product = state.products.product;
  return {
    isAuthenticated: state.auth.isAuthenticated,
    product,
    productId: ownProps.params.id,
    itemsMeta: state.items.meta,
    items: state.items.results,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(ProductViewPage));



// WEBPACK FOOTER //
// ./src/containers/ProductViewPage.js